module.exports = __webpack_public_path__ + "img/genhemp.a61783fa.png";